module.exports = __webpack_public_path__ + "static/img/ware2019.727d0b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ware2019.png
// module id = VfTk
// module chunks = 0